import Auth, { UserData } from './auth'

export default class MockAuth extends Auth {
  getUserData(): Promise<UserData> {
    throw new Error('Method not implemented.')
  }
  async init(): Promise<void> {}

  async resolveToken(): Promise<string> {
    return 'mock-token'
  }

  async refreshToken(): Promise<void> {}

  async logout(): Promise<void> {}
}
